module.exports = __webpack_public_path__ + "img/MTCICRED.c795c044.png";